import { gql } from '@apollo/client'

export const PublicRooms = gql`
  query PublicRooms {
    publicRooms(orderBy: ACTIVITY) {
      cursor
      rooms {
        id
        name
        topic
        spinning
        public
        members { id lastActivity }
        queue {
          id
          track { id title artist }
        }
      }
    }
  }
`

export default PublicRooms
